import { React, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/TableForArchive.css';
import { defaultCellRender } from '../../utils/formatValueForHTML';
import Table from '../Table/Table';
import { convertMillisecondsToDate } from '../../utils/convertToDate';
import { useSelector } from 'react-redux';

function TableForArchive({ hasInitialRequest, t, bottomBoundaryRef}) {
  let navigate = useNavigate();

  // Получение данных о бригадах из Redux store
  const { archiveSession } = useSelector((state) => state.archive);

  const handleRowClick = (value, row) => {
    navigate(`/archive/${row._id}`);
  };

  const columns = useMemo(
    () => [
      {
        Header: t?.tableHeaderID || 'ID ИУР',
        accessor: 'brigadeId',
        Cell: ({ cell: { value } }) => (
          <div className="table-for-cell-id">
            <span className="cell-id-icon"></span>
            <span className="cell-id-value">{value}</span>
          </div>
        ),
      },
      {
        Header: t?.tableHeaderStart || 'Начало',
        accessor: 'start',
        Cell: ({ value }) => defaultCellRender(convertMillisecondsToDate(value)),
      },
      {
        Header: t?.tableHeaderFinish || 'Конец',
        accessor: 'finish',
        Cell: ({ value }) => defaultCellRender(convertMillisecondsToDate(value)),
      },
      {
        Header: t?.tableHeaderRoad || 'Дорога',
        accessor: 'road',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.tableHeaderDepartment || 'Подразделение',
        accessor: 'department',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.tableHeaderStation || 'Станция/перегон',
        accessor: 'station',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.tableHeaderObject || 'Объект',
        accessor: 'obj',
        Cell: ({ value }) => defaultCellRender(value),
      },
      {
        Header: t?.tableHeaderRail || 'РЦ',
        accessor: 'railName',
        Cell: ({ value }) => defaultCellRender(value),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [archiveSession, t]
  );

  return (
    <div className="table-for-archive_container">
      {/* Компонент таблицы */}
      <Table
        data={archiveSession}
        columns={columns}
        showGlobalSearch={false}
        open={handleRowClick}
        bottomBoundaryRef={bottomBoundaryRef}
        arrLength={archiveSession?.length}
        text={
          hasInitialRequest
            ? archiveSession?.length === 0
              ? t?.noDataForSelectedParams || 'По выбранным параметрам данные отсутствуют'
              : ''
            : t?.enterFilterParams || 'Введите параметры фильтра'
        }
      />
    </div>
  );
}

export default TableForArchive;
